import DuraflowCategoryPage from '@/pages/equipamentos-e-componentes/components/DuraflowCategoryPage';
import useSeo from '@/hooks/useSeo';

export default function ValvulasControlePage() {
  useSeo({
    title: 'Válvulas de Controle Hidráulico | Duraflow',
    description: 'Válvulas reguladoras de vazão, proporcionais, de controle de carga e cartuchos hidráulicos para automação e eficiência energética.',
    keywords: 'válvulas de controle, válvulas proporcionais, válvulas reguladoras, componentes hidráulicos, DURAFLOW, Grupo Pilar',
    canonical: 'https://www.pilarmanutencao.com.br/valvulas-de-controle',
    ogUrl: 'https://www.pilarmanutencao.com.br/valvulas-de-controle',
    ogImage: '/images/EQUIPAMENTOS-E-COMPONENTES/NOSSOS-PRODUTOS/VALVULAS-DE-CONTROLE/CARD/VALVULAS-DE-CONTROLE.webp',
  });

  return (
    <DuraflowCategoryPage
      title="Válvulas de Controle"
      subtitle="Válvulas de controle de fluxo, pressão e direção para automação, segurança e eficiência energética em sistemas hidráulicos."
      heroImage="/images/EQUIPAMENTOS-E-COMPONENTES/NOSSOS-PRODUTOS/VALVULAS-DE-CONTROLE/HERO/HERO-VALVULAS-DE-CONTROLE.webp"
      heroImageAlt="Válvulas de controle hidráulico industrial"
      description="As válvulas de controle DURAFLOW oferecem precisão na regulação de sistemas hidráulicos, desde controle simples de abertura e fechamento até regulação proporcional integrada com eletrônica. São essenciais para aplicações que exigem repetibilidade, segurança e eficiência no consumo energético."
      applications={[
        'Sistemas de automação industrial',
        'Controle de velocidade de atuadores',
        'Proteção contra sobrecargas',
        'Máquinas CNC e robótica',
        'Sistemas de posicionamento síncrono',
        'Indústria de transformação e embalagem',
      ]}
      types={[
        {
          title: 'Válvulas Reguladoras de Vazão',
          description:
            'Válvulas reguladoras e estranguladoras para controle fino da velocidade de avanço e retorno de cilindros e motores hidráulicos.',
        },
        {
          title: 'Válvulas de Controle de Pressão',
          description:
            'Válvulas redutoras de pressão, alívio e sequência para manter a pressão de trabalho dentro dos limites seguros do sistema.',
        },
        {
          title: 'Válvulas Proporcionais',
          description:
            'Válvulas proporcionais com acionamento eletrônico para controle contínuo e proporcional de vazão e pressão em circuitos fechados.',
        },
        {
          title: 'Válvulas de Controle de Carga',
          description:
            'Válvulas de contrabalanço e segurança para controle de cargas que tendem a cair, evitando movimentos bruscos e acidentes.',
        },
        {
          title: 'Cartuchos Hidráulicos',
          description:
            'Válvulas cartucho de controle, alívio e retenção para montagem em blocos manifold de alta densidade e manutenção simplificada.',
        },
        {
          title: 'Unidades Hidráulicas Inteligentes',
          description:
            'Conjuntos de válvulas integradas com sensores e controlador eletrônico para automação completa e monitoramento remoto.',
        },
      ]}
      differentials={[
        'Estoque de válvulas proporcionais com bobinas e amplificadores compatíveis',
        'Serviço de programação e ajuste de cartões amplificadores para válvulas servo',
        'Análise de circuito e dimensionamento de válvulas de controle para novos projetos',
        'Manutenção e recalibração de válvulas proporcionais com teste em bancada dedicada',
        'Suporte técnico para integração de válvulas de controle em sistemas automatizados',
      ]}
    />
  );
}